import IcCached from './IcCached'

export default IcCached
